//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config/index';
export default {
  name: "notices",
  data: function data() {
    return {};
  },
  components: {},
  porps: {},
  computed: {
    getDocUrl: function getDocUrl() {
      var root = "";

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      console.log(root + "/static/fwtk.docx");
      return root + "/static/fwtk.docx";
    }
  },
  methods: {},
  mounted: function mounted() {}
};